import React, { useEffect, useState } from "react";
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  ArrowUpIcon,
  ArrowDownIcon,
} from "@heroicons/react/24/outline";

const TableComponent = ({ headers, data, itemsPerPage = 10, settings }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageData, setPageData] = useState(data);
  const [sortConfig, setSortConfig] = useState({ key: "", direction: "asc" });
  const totalPages = Math.ceil(data?.length / itemsPerPage);

  useEffect(() => {
    setPageData(data);
  }, [data]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const paginateData = (data) => {
    const start = (currentPage - 1) * itemsPerPage;
    const end = start + itemsPerPage;
    return data?.slice(start, end);
  };

  const sortData = (data, key) => {
    const direction = sortConfig.direction === "asc" ? 1 : -1;
    return [...data].sort((a, b) => {
      if (a[key] < b[key]) return -1 * direction;
      if (a[key] > b[key]) return 1 * direction;
      return 0;
    });
  };

  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
    setPageData(sortData(pageData, key));
  };
  const currentData = paginateData(pageData);

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse hover table-zebra">
        <thead>
          <tr>
            {headers
              .filter((header) =>
                typeof header.visible === "function"
                  ? currentData.some((item) => header.visible(item))
                  : header.visible !== false
              )
              .map((header) => (
                <th
                  key={header.key}
                  className="px-4 py-2 cursor-pointer bg-base-200 border"
                  onClick={() => handleSort(header.key)}
                >
                  <div className="flex items-center justify-between">
                    <span>{header.label}</span>
                    {sortConfig.key === header.key &&
                      (sortConfig.direction === "asc" ? (
                        <ArrowUpIcon className="w-4 h-4 text-blue-500" />
                      ) : (
                        <ArrowDownIcon className="w-4 h-4 text-blue-500" />
                      ))}
                  </div>
                </th>
              ))}
          </tr>
        </thead>
        <tbody className="hover">
          {currentData?.map((item, index) => (
            <tr key={index} className="hover">
              {headers
                ?.filter((header) =>
                  typeof header.visible === "function"
                    ? header.visible(item)
                    : header.visible !== false
                )
                .map((header) => (
                  <td key={header.key} className="px-4 py-2 border">
                    {header.key === "setting" && settings?.renderSettings
                      ? settings.renderSettings(item, index)
                      : header.render
                      ? header.render(item, index)
                      : item[header.key]}
                  </td>
                ))}
            </tr>
          ))}
        </tbody>
      </table>

      <div className="flex items-center justify-between mt-4 px-4 mb-4">
        <div className="text-sm text-gray-500">
          Hiển thị {currentData?.length} của {data?.length}
        </div>
        <div className="flex flex-wrap justify-center space-x-1 sm:space-x-2">
          <button
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
            className="p-2 border rounded-md shadow-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center text-xs sm:text-sm sm:p-2.5"
          >
            <ChevronLeftIcon className="w-3 h-3 sm:w-4 sm:h-4" />
            <ChevronLeftIcon className="w-3 h-3 sm:w-4 sm:h-4 -ml-1" />
          </button>
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="p-2 border rounded-md shadow-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm sm:p-2.5"
          >
            <ChevronLeftIcon className="w-3 h-3 sm:w-4 sm:h-4" />
          </button>
          <span className="px-3 py-1 text-xs font-medium text-gray-700 border rounded-md sm:text-sm sm:px-4 sm:py-2">
            {currentPage} / {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="p-2 border rounded-md shadow-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed text-xs sm:text-sm sm:p-2.5"
          >
            <ChevronRightIcon className="w-3 h-3 sm:w-4 sm:h-4" />
          </button>
          <button
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            className="p-2 border rounded-md shadow-sm hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed flex items-center text-xs sm:text-sm sm:p-2.5"
          >
            <ChevronRightIcon className="w-3 h-3 sm:w-4 sm:h-4" />
            <ChevronRightIcon className="w-3 h-3 sm:w-4 sm:h-4 -ml-1" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default TableComponent;
